<form nz-form class="form" [formGroup]="emailForm">
  <nz-form-item>
    <nz-form-label nzFor="username">Admin Email</nz-form-label>
    <nz-form-control>
      <input
        nz-input
        id="username"
        name="username"
        [value]="userData?.email ?? ''"
        [disabled]="true" />
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzFor="subject">Subject</nz-form-label>
    <nz-form-control>
      <input
        [disabled]="true"
        nz-input
        id="subject"
        name="subject"
        formControlName="subject" />
    </nz-form-control>
  </nz-form-item>
  <div class="title-wrapper mb-16">
    <h3 class="title s-16">Email Body</h3>
  </div>
  <nz-descriptions class="email-bosy-wrapper" id="email-body">
    <nz-descriptions-item nzTitle="From" nzSpan="3">
      {{ userData?.email }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Student's Name" nzSpan="3">
      {{ caseDetail?.student?.firstName }} {{ caseDetail?.student?.lastName }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle=" Student ID" nzSpan="3">
      {{ caseDetail?.student?.enrollId }}
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Behavior" nzSpan="3">
      {{ drawerParams?.behavior?.behaviorCategoryName }}
    </nz-descriptions-item>
  </nz-descriptions>
  <nz-form-item>
    <nz-form-label nzFor="userVendor"> Additional Comments </nz-form-label>
    <nz-form-control>
      <textarea
        id="userVendor"
        name="userVendor"
        nz-input
        formControlName="additionalComments">
      </textarea>
    </nz-form-control>
  </nz-form-item>
</form>
